<template>
  <div class="size">
    <highcharts-container :defOptions="options" :styles="sty" style="width:100%;margin: auto;"></highcharts-container>
  </div>
</template>

<script>
  import HighchartsContainer from './common/HighchartsComponent.vue'

  export default {
    name: "PerformanceCharts",
    components: {
      HighchartsContainer
    },
    props: ['isEnglish'],
    data() {
      if (!this.isEnglish) {
        return {
          sty: {
            width: '100%',
            height: '400px',
          },
          options: {
            title: {
              text: 'Tigo与同类型框架的性能对比',
              x: -20 // center
            },
            chart: {
              type: 'column'
            },
            xAxis: {
              categories: [
                "Tigo",
                "alberliu/goweb",
                "iissy/goweb",
                "Tornado",
                "gin",
              ]
            },
            yAxis: {
              title: {
                text: '访问量/每秒'
              },
              // 标示线
              plotLines: [{
                value: 0,
                width: 1,
                color: '#808080'
              }]
            },
            plotOptions: {
              column: {
                pointPadding: 0.2,
                borderWidth: 0,
                dataLabels: {
                  enabled: true //设置显示对应y的值
                }
              }
            },
            tooltip: {
              valueSuffix: '访问量/每秒' // 提示信息所带单位
            },
            legend: {
              enabled: false //  禁用图例
            },
            credits: {
              enabled: false // 禁用版权信息
            },
            series: [{
              name: 'QPS',
              data: [
                {
                  y: 31581.7,
                  color: '#797e8e',
                },
                {
                  y: 21529.6,
                  color: '#808080',
                },
                {
                  y: 22460.9,
                  color: '#808080',
                },
                {
                  y: 10526.1,
                  color: '#808080',
                },
                {
                  y: 36239.5,
                  color: '#808080',
                }
              ]
            }]
          }
        }
      }
      return {
        sty: {
          width: '100%',
          height: '400px',
        },
        options: {
          title: {
            text: 'Performance Comparison',
            x: -20 // center
          },
          chart: {
            type: 'column'
          },
          xAxis: {
            categories: [
              "Tigo",
              "alberliu/goweb",
              "iissy/goweb",
              "Tornado",
              "gin",
            ]
          },
          yAxis: {
            title: {
              text: 'requests/sec'
            },
            // 标示线
            plotLines: [{
              value: 0,
              width: 1,
              color: '#808080'
            }]
          },
          plotOptions: {
            column: {
              pointPadding: 0.2,
              borderWidth: 0,
              dataLabels: {
                enabled: true //设置显示对应y的值
              }
            }
          },
          tooltip: {
            valueSuffix: 'requests/sec' // 提示信息所带单位
          },
          legend: {
            enabled: false //  禁用图例
          },
          credits: {
            enabled: false // 禁用版权信息
          },
          series: [{
            name: 'QPS',
            data: [
              {
                y: 31581.7,
                color: '#797e8e',
              },
              {
                y: 21529.6,
                color: '#808080',
              },
              {
                y: 22460.9,
                color: '#808080',
              },
              {
                y: 10526.1,
                color: '#808080',
              },
              {
                y: 36239.5,
                color: '#808080',
              }
            ]
          }]
        }
      }
    }
  }
</script>

<style>
.size {
  margin: 50px 18%;
}
</style>



// WEBPACK FOOTER //
// src/components/PerformanceCharts.vue